export default __webpack_public_path__ + "static/media/29_mobile.dd682bca.jpg";